export default __webpack_public_path__ + "4e8cea18952c83074ec35f7bf1b176c4.ttf";